<template>
  <div>
    <form-table style="padding: 0; margin-top: 10px">
      <template slot="table">
        <v-data-table
            ref="table"
            :headers="colunas"
            :items="itens"
            :server-items-length="totalItens"
            :options.sync="paginacaoInterna"
            :loading="false"
            no-data-text="Não há orçamentos registrados para o filtro."
            class="table-list"
            hide-default-footer
            @click:row="tratarEventoAcessar">
          <template #item.codigo="{ item }">
            <span>{{ item.codigo | textoSemValor }}</span>
          </template>
          <template #item.descricao="{item}">
            <MolensTooltip max-width="300px">
              <span class="max-label">{{ item.descricao | textoSemValor }}</span>
              <template #content>
                {{ item.descricao | textoSemValor }}
              </template>
            </MolensTooltip>
          </template>
          <template #item.status="{item}">
            <span>{{ item.status | textoSemValor }}</span>
          </template>
          <template #item.dentista="{item}">
            <div v-if="item.dentista" class="d-flex align-center">
              <div>
                <foto-avatar :foto-url="item.dentista.foto" class-avatar="imagem-dentista"/>
              </div>
              <span class="ml-2">{{ item.dentista.nome | textoSemValor }}</span>
            </div>
            <div v-else>
              <span>{{ null | textoSemValor }}</span>
            </div>
          </template>
          <template #item.acoes="{ }">
            <v-icon>keyboard_arrow_right</v-icon>
            <span class="mobile">Acessar</span>
          </template>
        </v-data-table>
      </template>
    </form-table>
  </div>
</template>

<script>
import FormTable from '@/views/components/FormTable.vue'
import MolensTooltip from '@/views/components/MolensTooltip.vue'
import FotoAvatar from '@/views/components/FotoAvatar.vue'

export default {
    name: 'PacienteFichaOrcamentoTabela',
    components: {FotoAvatar, MolensTooltip, FormTable},
    props: {
        itens: Array,
        paginacao: Object,
        totalItens: Number,
    },
    data() {
        return {
            colunas: [
                {
                    text: 'Código',
                    value: 'codigo',
                    sortable: false,
                    align: 'left',
                    width: '10%',
                    class: 'gray--text'
                },
                {
                    text: 'Descrição',
                    value: 'descricao',
                    sortable: false,
                    align: 'left',
                    width: '30%',
                    class: 'gray--text'
                },
                {
                    text: 'Status',
                    value: 'status',
                    sortable: false,
                    align: 'left',
                    width: '20%',
                    class: 'gray--text'
                },
                {
                    text: 'Dentista',
                    value: 'dentista',
                    sortable: false,
                    align: 'left',
                    width: '30%',
                    class: 'gray--text'
                },
                {
                    text: '',
                    value: 'acoes',
                    sortable: false,
                    align: 'right',
                    width: '10%',
                    class: 'gray--text'
                }
            ],
            paginacaoInterna: this.paginacao
        }
    },
    methods: {
        tratarEventoAcessar(item) {
            this.$emit('acessar', item)
        }
    },
}
</script>


<style scoped lang="stylus">

.max-label
  display inline-block
  max-width 40vw
  white-space nowrap
  overflow hidden
  text-overflow ellipsis

.imagem-dentista
  width 40px
  height 40px
  border-radius 50%
  border 2px solid #eee

</style>